import { HttpError } from "@nestia/fetcher";
import api from "@api";
import { getConnection } from "@app/sdk";

import type { PendingInvitation } from "@entities/invitation";

const defaultResponse: PendingInvitation[] = [];

export const getPendingInvitations = async (): Promise<PendingInvitation[]> => {
  try {
    const response =
      await api.functional.invitations.pending.getPendingInvitations(
        getConnection(),
      );
    return (response.responseObject as PendingInvitation[]) ?? defaultResponse;
  } catch (e) {
    if (e instanceof HttpError) {
      return defaultResponse;
    }
    throw e;
  }
};
